module.exports = __webpack_public_path__ + "static/media/hi_mid_freq.fe35f882.png";